import { BaseModel } from '@/api/base-model'
import { TriggeredReferralAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { Company } from '@/api/model/company'
import { RealworksCredentials } from '@/api/model/credentials'
import { Pipeline } from '@/api/model/pipeline'
import { Source } from '@/api/model/source'

export class TriggeredReferral extends BaseModel<TriggeredReferral> {
    protected collectionName = TriggeredReferralAPI.collectionName

    constructor(
        public id: string,
        public company: Company,
        public realworksCredentials: RealworksCredentials|null,
        public realworksKenmerkId: string|null,
        public agendaTypes: string[],
        public agendaStatus: string|null,
        public taakTypes: string[],
        public taakStatus: string|null,
        public relatieTypes: string[],
        public referralPipeline: Pipeline|null,
        public referralType: string|null,
        public referralReferredByPreference: string|null,
        public referralReferredByBranch: Branch|null,
        public referralReferredBy: User|null,
        public referralAssignedToBranch: Branch|null,
        public referralAssignedTo: User|null,
        public referralSource: string,
        public referralNewSource: Source|null,
        public referralComment: string,
        public maxDaysForExistingReferrals: number,
        public active: boolean,
        public createdAt: Date|null,
        public updatedAt: Date|null,
    ) {
        super(id)
    }

    get triggerType(): string {
        if (this.realworksKenmerkId) {
            return 'kenmerken'
        } else if (this.agendaTypes.length > 0) {
            return 'agendaTypes'
        } else if (this.taakTypes.length > 0) {
            return 'taakTypes'
        } else if (this.relatieTypes.length > 0) {
            return 'relatieTypes'
        } else {
            return 'kenmerken'
        }
    }

    static fromData(data: any) {
        if (data === null || typeof data === 'string' || data instanceof TriggeredReferral) {
            return data
        }

        return new TriggeredReferral(
            data.id,
            data.company ? Company.fromData(data.company) : null,
            data.realworksCredentials ? RealworksCredentials.fromData(data.realworksCredentials) : null,
            data.realworksKenmerkId,
            data.agendaTypes ?? [],
            data.agendaStatus,
            data.taakTypes ?? [],
            data.taakStatus,
            data.relatieTypes ?? [],
            data.referralPipeline ? Pipeline.fromData(data.referralPipeline) : null,
            data.referralType,
            data.referralReferredByPreference,
            data.referralReferredByBranch ? Branch.fromData(data.referralReferredByBranch) : null,
            data.referralReferredBy ? User.fromData(data.referralReferredBy) : null,
            data.referralAssignedToBranch ? Branch.fromData(data.referralAssignedToBranch) : null,
            data.referralAssignedTo ? User.fromData(data.referralAssignedTo) : null,
            data.referralSource,
            data.referralNewSource ? Source.fromData(data.referralNewSource) : null,
            data.referralComment,
            data.maxDaysForExistingReferrals,
            data.active,
            data.createdAt,
            data.updatedAt,
        )
    }
}
